import router from './router'
import store from './store'
import {
    getToken,
    getEnterToken
} from '@/utils/auth'
import Util from '@/utils/util'

const whiteList = ['/login']
let flag = false
let adminJumpHandled = false

function getHashQueryParam(key) {
    const hash = window.location.hash || ''
    const qIdx = hash.indexOf('?')
    if (qIdx < 0) return ''
    try {
        return new URLSearchParams(hash.slice(qIdx + 1)).get(key) || ''
    } catch (e) {
        return ''
    }
}

function getAdminProjectPayload(to) {
    if (adminJumpHandled) return null
    let project = (to.query && to.query.project) || getHashQueryParam('project')
    if (!project) return null
    try {
        return decodeURIComponent(window.atob(decodeURIComponent(project)))
    } catch (e) {
        console.error('admin project param decode failed', e)
        return null
    }
}

router.beforeEach(async (to, from, next) => {
    if (to.path === '/person' || to.path === '/index') {
        const adminInfo = getAdminProjectPayload(to)
        if (adminInfo) {
            adminJumpHandled = true
            const loginResult = Util.fnSetLoginInfo(adminInfo)
            if (loginResult === 'fresh_login' || loginResult === 'same_user' || loginResult === 'switch_user') {
                return next({ path: to.path, query: {}, replace: true })
            }
            if (loginResult === false) {
                return
            }
        }
    }
    const hasToken = getToken()
    const hasEnter = getEnterToken()

    if (hasToken) {
        if (to.path === '/login') {
            next('/')
        } else {
            const regionId = await store.dispatch('getRegionId')

            // 刷新时需重新添加路由
            if (flag === false) {
                store.dispatch('generateRoutes', regionId).then(res => {
                    router.addRoutes(res)
                    flag = true
                    next({ ...to,
                        replace: true
                    })
                })
            } else {
                next()
            }
        }
    } else {
        if (hasEnter) {
            if (to.path === '/enter' || to.path === '/login') {
                next()
            } else {
                next({
                    path: '/enter'
                })
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) {
                next()
            } else {
                next({
                    path: '/login?direction=' + from.path
                })
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/permission.js